export default function pluralise(n: number, singular: string, plural = `${singular}s`) {
	return `${n} ${n === 1 ? singular : plural}`;
}
